import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { view } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import topbar from 'src/js/modules/topbar';

const { Preloader } = designSystem;

function ViewLoaderContainer({ loadedStatus, topbarHeight = 0 }) {
  const isStatusTextPresent = typeof loadedStatus === 'string';
  const isLoading = isStatusTextPresent || !loadedStatus;
  const loaderClass = classNames('ws-view-loader', {
    'ws-view-loader__active': isLoading,
  });

  if (!isLoading) return null;

  return (
    <div className={loaderClass} style={{ top: topbarHeight }}>
      <Preloader indeterminate label={isStatusTextPresent ? loadedStatus : null} />
    </div>
  );
}

ViewLoaderContainer.propTypes = {
  loadedStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  topbarHeight: PropTypes.number,
};

const mapStateToProps = (state) => ({
  loadedStatus: view.selectors.getLoadedStatus(state),
  topbarHeight: topbar.selectors.getHeight(state),
});

export default connect(mapStateToProps)(ViewLoaderContainer);
